import EmptyState from '@/components/linear/empty-state';
import IssueList from '@/components/linear/issue-list';
import PageToolbar from '@/components/linear/page-toolbar';
import { inboxPath, openIssuePath, projectPath, projectsPath } from '@/lib/linear-paths';
import type { Company } from '@/types/company';
import type { Issue } from '@/types/issue';
import type { Project } from '@/types/project';
import { Link, router } from '@inertiajs/react';

interface Props {
  companies: Company[];
  currentCompany: Company | null;
  focusNow: Project[];
  focusCount: number;
  untriagedCapturesCount: number;
  untriagedPrsCount: number;
  blocked: Project[];
  activeProjectsCount: number;
  pendingAICount: number;
  issues?: Issue[];
}

export default function Index({
  currentCompany,
  focusNow,
  untriagedCapturesCount,
  untriagedPrsCount,
  blocked,
  issues = [],
}: Props) {
  const untriagedTotal = untriagedCapturesCount + untriagedPrsCount;

  return (
    <div className="ln-page">
      <PageToolbar
        title="My issues"
        tabs={
          <div className="ln-tabs">
            <span className="ln-tab" data-active="true">
              Assigned
            </span>
            <Link href={inboxPath()} className="ln-tab">
              Inbox
              {untriagedTotal > 0 ? <span className="ln-tab-count">{untriagedTotal}</span> : null}
            </Link>
          </div>
        }
      />
      <div className="ln-page-scroll">
        {issues.length > 0 ? (
          <IssueList issues={issues} onSelect={(issue) => router.visit(openIssuePath(issue))} />
        ) : (
          <>
            {focusNow.length === 0 && blocked.length === 0 ? (
              <EmptyState
                title={currentCompany ? currentCompany.name : 'CAP Rock Labs'}
                description="No assigned issues yet. Press C to create one."
              />
            ) : null}

            {focusNow.length > 0 ? (
              <section>
                <button type="button" className="ln-group-header">
                  Focus now
                  <span className="ln-group-count">{focusNow.length}</span>
                </button>
                {focusNow.map((project) => (
                  <Link key={project.id} href={projectPath(project.id)} className="ln-row">
                    <span className="ln-row-title">{project.name}</span>
                    <span className="ln-row-meta">
                      {project.statusBlocked ? (
                        <span className="ln-label" style={{ color: '#eb5757' }}>
                          Blocked
                        </span>
                      ) : null}
                      <span className="ln-inbox-sub">{project.statusNow || project.endState}</span>
                    </span>
                  </Link>
                ))}
              </section>
            ) : null}

            {blocked.length > 0 ? (
              <section>
                <button type="button" className="ln-group-header">
                  Blocked
                  <span className="ln-group-count">{blocked.length}</span>
                </button>
                {blocked.map((project) => (
                  <Link key={project.id} href={projectPath(project.id)} className="ln-row">
                    <span className="ln-row-title">{project.name}</span>
                    <span className="ln-row-meta">
                      <span className="ln-label" style={{ color: '#eb5757' }}>
                        Blocked
                      </span>
                      <span className="ln-inbox-sub">
                        {project.statusBlocked || project.statusNow}
                      </span>
                    </span>
                  </Link>
                ))}
              </section>
            ) : null}

            <div style={{ padding: 16 }}>
              <Link href={projectsPath()} className="ln-toolbar-btn">
                All projects
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
